import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChatPanelMinimize = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.25 8h9.5",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
});
export default SvgChatPanelMinimize;
